import * as i0 from '@angular/core';
import { Inject, ViewEncapsulation, Component, Injectable, NgModule } from '@angular/core';
import * as i1 from '@angular/material/snack-bar';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule } from '@angular/material/snack-bar';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i4 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
function KnsSnackbarComponent_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function KnsSnackbarComponent_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close());
    });
    i0.ɵɵelementStart(1, "mat-icon", 5);
    i0.ɵɵtext(2, "close");
    i0.ɵɵelementEnd()();
  }
}
let KnsSnackbarComponent = /*#__PURE__*/(() => {
  class KnsSnackbarComponent {
    constructor(data, snackRef) {
      this.data = data;
      this.snackRef = snackRef;
    }
    ngOnInit() {}
    close() {
      this.snackRef.dismiss();
    }
    get formattedMessage() {
      return this.data.message.replace(/\n/g, '<br>');
    }
    static {
      this.ɵfac = function KnsSnackbarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || KnsSnackbarComponent)(i0.ɵɵdirectiveInject(MAT_SNACK_BAR_DATA), i0.ɵɵdirectiveInject(i1.MatSnackBarRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: KnsSnackbarComponent,
        selectors: [["lib-kns-snackbar"]],
        standalone: false,
        decls: 5,
        vars: 4,
        consts: [[1, "snackbar-container", 3, "ngClass"], [1, "snackbar-icon", "text-white"], [1, "snackbar-message", "text-white", 2, "white-space", "pre-line", 3, "innerHTML"], ["mat-icon-button", "", 3, "click", 4, "ngIf"], ["mat-icon-button", "", 3, "click"], [1, "close-icon"]],
        template: function KnsSnackbarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "mat-icon", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(3, "span", 2);
            i0.ɵɵtemplate(4, KnsSnackbarComponent_button_4_Template, 3, 0, "button", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.data.snackbarTypeClass);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.data.icon);
            i0.ɵɵadvance();
            i0.ɵɵproperty("innerHTML", ctx.formattedMessage, i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.data.closeButton);
          }
        },
        dependencies: [i2.NgClass, i2.NgIf, i3.MatIcon, i4.MatIconButton],
        styles: [".snackbar-container{display:flex;align-items:center;color:#fff}.kns-snackbar-center{position:fixed!important;top:50%!important;left:50%!important;transform:translate(-50%,-50%)!important;z-index:1000}.kns-snackbar{border-radius:5px!important}.snackbar-icon{margin-right:12px;font-size:24px}.snackbar-message{flex:1;font-family:Roboto;font-size:16px}.background-success{background-color:#48ad4f!important}.background-warning{background-color:#f89406!important}.background-error{background-color:#bd362f!important}.background-info{background-color:#35a7dc!important}.text-white{color:#fff!important}.mat-mdc-snack-bar-container.background-success{--mdc-snackbar-container-color: #48ad4f !important}.mat-mdc-snack-bar-container.background-success .mdc-snackbar__label{padding:0 5px 0 12px}.mat-mdc-snack-bar-container.background-warning{--mdc-snackbar-container-color: #f89406 !important}.mat-mdc-snack-bar-container.background-warning .mdc-snackbar__label{padding:0 5px 0 12px}.mat-mdc-snack-bar-container.background-error{--mdc-snackbar-container-color: #bd362f !important}.mat-mdc-snack-bar-container.background-error .mdc-snackbar__label{padding:0 5px 0 12px}.mat-mdc-snack-bar-container.background-info{--mdc-snackbar-container-color: #35a7dc !important}.mat-mdc-snack-bar-container.background-info .mdc-snackbar__label{padding:0 5px 0 12px}\n"],
        encapsulation: 2
      });
    }
  }
  return KnsSnackbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let KnsSnackbarService = /*#__PURE__*/(() => {
  class KnsSnackbarService {
    constructor(snackBar) {
      this.snackBar = snackBar;
    }
    openSuccess(parameters) {
      this.open(parameters, KnsSnackbarType.Success);
    }
    openError(parameters) {
      this.open(parameters, KnsSnackbarType.Error);
    }
    openDefault(parameters) {
      this.open(parameters, KnsSnackbarType.Default);
    }
    openWarning(parameters) {
      this.open(parameters, KnsSnackbarType.Warning);
    }
    openInfo(parameters) {
      this.open(parameters, KnsSnackbarType.Info);
    }
    open(parameters, knsSnackbarType) {
      switch (knsSnackbarType) {
        case KnsSnackbarType.Success:
          const successParams = {
            icon: 'check_circle',
            snackbarTypeClass: 'background-success'
          };
          this.snackBar.openFromComponent(KnsSnackbarComponent, this.createConfig(parameters, successParams));
          break;
        case KnsSnackbarType.Error:
          const errorParams = {
            icon: 'error',
            snackbarTypeClass: 'background-error'
          };
          this.snackBar.openFromComponent(KnsSnackbarComponent, this.createConfig(parameters, errorParams));
          break;
        case KnsSnackbarType.Warning:
          const warningParams = {
            icon: 'warning',
            snackbarTypeClass: 'background-warning'
          };
          this.snackBar.openFromComponent(KnsSnackbarComponent, this.createConfig(parameters, warningParams));
          break;
        case KnsSnackbarType.Info:
          const infoParams = {
            icon: 'info',
            snackbarTypeClass: 'background-info'
          };
          this.snackBar.openFromComponent(KnsSnackbarComponent, this.createConfig(parameters, infoParams));
          break;
        case KnsSnackbarType.Default:
          const config = this.createConfig(parameters, null, true);
          if (!parameters.closeButtonText) {
            parameters.closeButtonText = null;
          }
          this.snackBar.open(parameters.message, parameters.closeButton ? parameters.closeButtonText ?? 'Zamknij' : '', config);
          break;
        default:
          break;
      }
    }
    createConfig(parameters, constParams, defaultStyles) {
      let styles = [];
      if (!defaultStyles) {
        styles = parameters.verticalPosition != 'center' ? [...this.createSnackbarClass(constParams?.snackbarTypeClass)] : [...this.createSnackbarClass(constParams?.snackbarTypeClass), 'kns-snackbar-center'];
      }
      const config = {
        duration: parameters.duration || 4000,
        politeness: 'off',
        horizontalPosition: parameters.horizontalPosition ?? 'center',
        verticalPosition: parameters.verticalPosition != 'center' ? parameters.verticalPosition : 'top',
        panelClass: styles,
        data: {
          message: parameters.message,
          icon: constParams?.icon ?? 'close',
          snackbarTypeClass: constParams?.snackbarTypeClass,
          closeButton: parameters.closeButton,
          closeButtonText: parameters.closeButtonText
        }
      };
      return config;
    }
    createSnackbarClass(backgroundClass) {
      const snackbarClass = 'kns-snackbar';
      return [snackbarClass, backgroundClass];
    }
    static {
      this.ɵfac = function KnsSnackbarService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || KnsSnackbarService)(i0.ɵɵinject(i1.MatSnackBar));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: KnsSnackbarService,
        factory: KnsSnackbarService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return KnsSnackbarService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var KnsSnackbarType = /*#__PURE__*/function (KnsSnackbarType) {
  KnsSnackbarType[KnsSnackbarType["Success"] = 0] = "Success";
  KnsSnackbarType[KnsSnackbarType["Error"] = 1] = "Error";
  KnsSnackbarType[KnsSnackbarType["Warning"] = 2] = "Warning";
  KnsSnackbarType[KnsSnackbarType["Info"] = 3] = "Info";
  KnsSnackbarType[KnsSnackbarType["Default"] = 4] = "Default";
  return KnsSnackbarType;
}(KnsSnackbarType || {});
let KnsSnackbarModule = /*#__PURE__*/(() => {
  class KnsSnackbarModule {
    static {
      this.ɵfac = function KnsSnackbarModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || KnsSnackbarModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: KnsSnackbarModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatSnackBarModule, MatIconModule, MatButtonModule]
      });
    }
  }
  return KnsSnackbarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of kns-snackbar
 */

/**
 * Generated bundle index. Do not edit.
 */

export { KnsSnackbarComponent, KnsSnackbarModule, KnsSnackbarService, KnsSnackbarType };
